import { render, staticRenderFns } from "./AddAiAppDirect.vue?vue&type=template&id=5c817fd7"
import script from "./AddAiAppDirect.vue?vue&type=script&lang=js"
export * from "./AddAiAppDirect.vue?vue&type=script&lang=js"
import style0 from "./AddAiAppDirect.vue?vue&type=style&index=0&id=5c817fd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports